// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorPageLayout_wrapper__UdITh","contentWrapper":"ErrorPageLayout_contentWrapper__1NrQs","imageWrapper":"ErrorPageLayout_imageWrapper__3w_zD"};